import React from 'react';
import {
  Paper,
  Box,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Chip,
  Tooltip,
  IconButton
} from '@mui/material';
import {
  Payment as PaymentIcon,
  Visibility as VisibilityIcon
} from '@mui/icons-material';
import { formatCurrency, formatDate, getEstadoColor } from '../../utils/liquidacionHelpers';

/**
 * Componente de tabla de pagos pendientes de confirmar
 * @param {Array} pagosPendientes - Lista de pagos
 * @param {Function} onVerDetalle - Callback al hacer clic en ver detalle
 */
const TablaPagosPendientes = ({ pagosPendientes = [], onVerDetalle }) => {
  return (
    <Paper sx={{ mb: 4, borderRadius: 3 }}>
      {/* Header */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #FF9800 0%, #F57C00 100%)',
          color: 'white',
          p: 3,
          borderTopLeftRadius: 12,
          borderTopRightRadius: 12
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 2 }}>
          <PaymentIcon />
          Pagos Generados - Pendientes de Confirmar ({pagosPendientes.length})
        </Typography>
      </Box>

      <TableContainer>
        <Table>
          <TableHead sx={{ bgcolor: 'rgba(255, 152, 0, 0.1)' }}>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold' }}>ID Pago</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Trabajador</TableCell>
              <TableCell align="center" sx={{ fontWeight: 'bold' }}>
                Servicios
              </TableCell>
              <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                Monto Bruto
              </TableCell>
              <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                Descuentos
              </TableCell>
              <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                Monto Neto
              </TableCell>
              <TableCell align="center" sx={{ fontWeight: 'bold' }}>
                Estado
              </TableCell>
              <TableCell align="center" sx={{ fontWeight: 'bold' }}>
                Fecha
              </TableCell>
              <TableCell align="center" sx={{ fontWeight: 'bold' }}>
                Acciones
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pagosPendientes.map((pago) => (
              <TableRow
                key={pago.id_pago}
                sx={{ '&:hover': { bgcolor: 'rgba(255, 152, 0, 0.04)' } }}
              >
                <TableCell>
                  <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                    #{pago.id_pago}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="subtitle1">
                    {pago.nombre_trabajador} {pago.apellido_trabajador}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    📱 {pago.telefono_trabajador}
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Chip label={pago.cantidad_servicios} color="primary" size="small" />
                </TableCell>
                <TableCell align="right">
                  <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                    {formatCurrency(pago.monto_bruto)}
                  </Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 'bold',
                      color: pago.monto_descuentos > 0 ? '#FF5722' : '#757575'
                    }}
                  >
                    -{formatCurrency(pago.monto_descuentos)}
                  </Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 'bold',
                      color: '#4CAF50',
                      fontSize: '1.1rem'
                    }}
                  >
                    {formatCurrency(pago.monto_neto)}
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Chip label={pago.estado} color={getEstadoColor(pago.estado)} size="small" />
                </TableCell>
                <TableCell align="center">
                  <Typography variant="body2" color="text.secondary">
                    {formatDate(pago.fecha_generacion)}
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Tooltip title="Ver detalle y gestionar pago">
                    <IconButton color="primary" onClick={() => onVerDetalle(pago)}>
                      <VisibilityIcon />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Mensaje cuando no hay pendientes */}
      {pagosPendientes.length === 0 && (
        <Box sx={{ p: 4, textAlign: 'center' }}>
          <PaymentIcon sx={{ fontSize: 60, color: '#FF9800', mb: 2 }} />
          <Typography variant="h6" color="text.secondary">
            No hay pagos pendientes de confirmar
          </Typography>
        </Box>
      )}
    </Paper>
  );
};

export default TablaPagosPendientes;
